import { BundleInfo, BundleId, CapacitorUpdater } from "@capgo/capacitor-updater";
import { sportTitle } from "../admin_actions/apiUtils";
import { useModalStore } from "@/store/modalStore";
import { isMobileApp } from "./mobileAppServices";
import UpdateAppPopUp from "@/components/MobileAppComponents/UpdateAppPopUp.vue";
import MajorUpdateAppPopUp from "@/components/MobileAppComponents/MajorUpdateAppPopUp.vue";
import { useUserDataStore } from "@/store/userDataStore";
import { App } from '@capacitor/app'
import { Capacitor } from "@capacitor/core";
import { axiosLevelTech } from "../axiosConfig";



/**
 * Checks for updates and applies them if available.
 */
export async function checkForUpdates(): Promise<void> {

  if (!isMobileApp()) {
    return;
  }

  CapacitorUpdater.addListener('downloadComplete', async (event) => {
    console.log("Update downloaded, showing modal...");
    //if second number in version is greater than the installed bundle version, show major update popup
    let currentBundle = await CapacitorUpdater.current();
    if (event.bundle.version.split('.')[1] > currentBundle.bundle.version.split('.')[1]) {
      await DisplayMajorUpdatePopUp(event.bundle);
    } else {
      await DisplayUpdatePopUp(event.bundle);
    }
  });

  await checkForUpdatesAfterFetch();

  App.addListener('appStateChange', async (state) => {
    if (state.isActive) {
      // Check for updates when the app becomes active
      await checkForUpdatesAfterFetch();
    }
  });


}

async function DisplayUpdatePopUp(bundle: BundleInfo) {
  const modalStore = useModalStore();
  modalStore.openModal({
    title: 'Update Available!',
    description: '',
    component: UpdateAppPopUp,
    props: {
      version: bundle,
    },
  });
}

async function DisplayMajorUpdatePopUp(bundle: BundleInfo) {
  const modalStore = useModalStore();
  modalStore.openModal({
    title: 'Major Update Available!',
    description: '',
    component: MajorUpdateAppPopUp,
    props: {
      version: bundle,
    },
  });
}

async function checkForUpdatesAfterFetch() {

  try {
    //get the latest version from the intitialise call
    const latestVersion = await getCurrentAppVersion();

    console.log(`Latest version available: ${latestVersion}`);
    // Check for updates using LiveUpdate
    // see what the current version is from the preferences api
    const currentVersion = await CapacitorUpdater.current();
    console.log(`Current app version: ${currentVersion.bundle.version}`);
    if (latestVersion !== null && currentVersion.bundle.version !== latestVersion) {

      console.log("New update available, downloading update...");

      // Download the update
      const version = await CapacitorUpdater.download({
        version: latestVersion,
        url: `https://services.leveltech.io/app_updates/release-${sportTitle.value}-${latestVersion}.zip`,
      })

    } else {
      console.log("No updates available, app is up to date.");
    }
  } catch (error) {
    console.error("Error checking for updates:", error);
  }
}

export async function applyUpdate(version: BundleInfo): Promise<void> {
  const modalStore = useModalStore();

  try {
    let bundleId: BundleId = {
      id: version.id,
    };
    console.log("Applying update:", bundleId);
    await CapacitorUpdater.set(bundleId);
    console.log("Update applied successfully.");
    modalStore.closeModal();
  } catch (error) {
    console.error("Error applying update:", error);
  }
}

export async function openAppStorePage(): Promise<void> {
  //if capacitor platform is ios open app store page

  App.getInfo().then(info => {
    var appId = info.id;
    var appleAppStoreId = "6743806671"; //Hardcoded for now, change later when needed
    if (Capacitor.getPlatform() === 'ios') {
      //open link external browser to app store page
      window.open(`https://apps.apple.com/app/id${appleAppStoreId}`, '_blank');
    } else if (Capacitor.getPlatform() === 'android') {
      window.open(`https://play.google.com/store/apps/details?id=${appId}`, '_blank');
    }
  });
}

async function getCurrentAppVersion(): Promise<string | null> {
  try {
    const response = await axiosLevelTech.get('/api/app/GetCurrentAppVersion');
    return response.data.data ?? null;
  } catch (error) {
    console.error("Error getting current app version:", error);
    return null;
  }
}
